import { parseDollarAmt } from "./parseDollarAmt";
import { getCentAmount } from "./getCentAmount";

export function savedAmount(oldPrice, newPrice) {
  const dollarAmount = parseDollarAmt(oldPrice - newPrice);
  const centAmount = getCentAmount(oldPrice - newPrice);
  return `${dollarAmount}.${centAmount}`;
}
